import { api } from "./client";
import type {
  Event,
  EventCreateIn,
  EventUpdateIn,
  EventCompleteIn,
} from "@/types";

export async function listEvents(includeCompleted = false): Promise<Event[]> {
  const suffix = includeCompleted ? "?include_completed=true" : "";
  const { data } = await api.get<Event[]>(`/events${suffix}`);
  return data;
}

export async function getEvent(id: number): Promise<Event> {
  const { data } = await api.get<Event>(`/events/${id}`);
  return data;
}

export async function createEvent(payload: EventCreateIn): Promise<Event> {
  const { data } = await api.post<Event>("/events", payload);
  return data;
}

export async function updateEvent(id: number, payload: EventUpdateIn): Promise<Event> {
  const { data } = await api.put<Event>(`/events/${id}`, payload);
  return data;
}

export async function completeEvent(id: number, payload: EventCompleteIn): Promise<Event> {
  const { data } = await api.post<Event>(`/events/${id}/complete`, payload);
  return data;
}

export async function deleteEvent(id: number): Promise<void> {
  await api.delete(`/events/${id}`);
}
